import React, { useState } from 'react';
import { post } from '../httpClient';

const INPUT_TYPE = {
    text: 'text',
    email: 'email',
    phone: 'tel',
};

export default function InquiryFormRenderer({ comp }) {
    const [values, setValues] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const fields = comp.fields || [];

    const handleChange = (name, value) => setValues(prev => ({ ...prev, [name]: value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await post('forms/send', {
                formData: values,
                transportId: comp.transportId || null,
            });
            setSubmitted(true);
        } catch {
            // error already shown by httpClient toast
        } finally {
            setSubmitting(false);
        }
    };

    if (submitted) {
        return (
            <div className="inq-success">
                {comp.successMessage || 'Your message has been sent.'}
            </div>
        );
    }

    return (
        <div className="inq-wrapper">
            {comp.title && <h2 className="inq-title">{comp.title}</h2>}
            {comp.description && <p className="inq-desc">{comp.description}</p>}

            <form className="inq-form" onSubmit={handleSubmit} noValidate>
                {fields.map((field, idx) => (
                    <div key={idx} className="inq-field">
                        {field.type === 'checkbox' ? (
                            <label className="inq-checkbox-label">
                                <input
                                    type="checkbox"
                                    className="inq-checkbox"
                                    required={field.required}
                                    checked={!!values[field.name]}
                                    onChange={e => handleChange(field.name, e.target.checked)}
                                />
                                <span>
                                    {field.label || field.name}
                                    {field.required && <span className="inq-required"> *</span>}
                                </span>
                            </label>
                        ) : (
                            <>
                                <label className="inq-label">
                                    {field.label || field.name}
                                    {field.required && <span className="inq-required"> *</span>}
                                </label>
                                {field.type === 'textarea' ? (
                                    <textarea
                                        className="inq-control"
                                        placeholder={field.placeholder}
                                        required={field.required}
                                        rows={4}
                                        value={values[field.name] || ''}
                                        onChange={e => handleChange(field.name, e.target.value)}
                                    />
                                ) : field.type === 'select' ? (
                                    <select
                                        className="inq-control"
                                        required={field.required}
                                        value={values[field.name] || ''}
                                        onChange={e => handleChange(field.name, e.target.value)}
                                    >
                                        <option value="">{field.placeholder || '—'}</option>
                                        {(field.options || []).map((opt, oIdx) => (
                                            <option key={oIdx} value={opt}>{opt}</option>
                                        ))}
                                    </select>
                                ) : (
                                    <input
                                        type={INPUT_TYPE[field.type] || 'text'}
                                        className="inq-control"
                                        placeholder={field.placeholder}
                                        required={field.required}
                                        value={values[field.name] || ''}
                                        onChange={e => handleChange(field.name, e.target.value)}
                                    />
                                )}
                            </>
                        )}
                    </div>
                ))}

                <button type="submit" className="inq-submit" disabled={submitting}>
                    {submitting ? '…' : (comp.submitLabel || 'Send')}
                </button>
            </form>
        </div>
    );
}
